<template>
    <div class="courses-single-page bg-dark-blue" style="overflow-y: auto;">
        <div class="back-button">
            <button class="btn-save mr-1" v-on:click="save">Save</button>
            <button class="btn-back" v-on:click="goBack">Back</button>
        </div>
        <div class="container-fluid">
            <div v-if="site" class="row">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="course-single tab-content">
                            <div class="card mt-3 mb-3">
                                <div class="card-header pb-0">
                                    <div class="d-flex">
                                        <button v-on:click="setTab($event, 'info')" class="btn-add tab course-info-tab active">Site Info</button>
                                        <button v-if="!site.name || site.name.toLowerCase() !== 'cms'" v-on:click="setTab($event, 'design')" class="btn-add tab course-design-tab">Site Design</button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="container-fluid">
                                        <div class="container-fluid d-flex justify-content-between align-items-center">
                                            <div class="title" style="margin-top: 40px; margin-bottom: 20px">
                                                <h1>
                                                    {{activeTab == "info" ? "Site Details" : "Site Design"}}
                                                </h1>
                                            </div>

                                        </div>
                                        <div class="container-fluid site-info border-secondary" v-show="activeTab == 'info'">
                                            <div class="row">
                                                <div class="col-6">
                                                    <div>
                                                        <label>Name</label>
                                                        <input type="text" v-model="site.name" />
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div>
                                                        <label>URLs</label>
                                                        <br />
                                                        <div v-for="(domain, idx) in site.domains">
                                                            <input type="text" v-model="site.domains[idx]" /> <br />
                                                        </div>
                                                        <button class="btn-cms-green" type="button" v-on:click="site.domains.push('')">Add domain</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <label>From Email</label>
                                                <input type="text" v-model="site.fromEmail" />
                                            </div>
                                            <div>
                                                <label>Paygate Id</label>
                                                <input type="text" v-model="site.paygateId" />
                                            </div>
                                            <div>
                                                <label>Paygate Secret</label>
                                                <input type="text" v-model="site.paygateSecret" />
                                            </div>
                                            <div>
                                                <label>Billing Address</label>
                                                <textarea type="text" v-model="site.billingAddress" rows="5"></textarea>
                                            </div>
                                            <div>
                                                <label>Host Directory</label>
                                                <input type="text" v-model="site.hostDirectory" />
                                            </div>
                                            <div>
                                                <label>Auto Enrollment</label><br />
                                                <input type="checkbox" v-model="site.autoEnrollment" />
                                            </div>

                                            <div>
                                                <label>SMTP Hostname</label>
                                                <input type="text" v-model="site.smtpHostname" />
                                            </div>
                                            <div>
                                                <label>SMTP Port</label>
                                                <input type="text" v-model="site.smtpPort" />
                                            </div>
                                            <div>
                                                <label>SMTP Username</label>
                                                <input type="text" v-model="site.smtpUsername" />
                                            </div>
                                            <div>
                                                <label>SMTP Password</label>
                                                <input type="text" v-model="site.smtpPassword" />
                                            </div>
                                            <div>
                                                <label>Entra Client ID</label>
                                                <input type="text" v-model="site.entraClientID" />
                                            </div>
                                            <div>
                                                <label>Entra Tenant ID</label>
                                                <input type="text" v-model="site.entraTenantID" />
                                            </div>

                                            <div v-if="additionalProperties && additionalProperties.length > 0">
                                                <label>Additional Properties</label>
                                                <ul class="list-group">
                                                    <li class="list-group-item" v-for="property in additionalProperties" :key="property">
                                                        <div class="container-fluid d-flex justify-content-between">
                                                            <label>{{ property }}</label>
                                                            <input type="checkbox" :value="property" v-model="site.additionalProperties" />
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div>
                                                <div>
                                                    <label>Divisions</label>
                                                    <br />

                                                    <div v-if="site.divisions.length == 0" style="font-weight: 100; margin-bottom: 10px">No Divisions Configured</div>

                                                    <div>
                                                        <input v-for="(domain, idx) in site.divisions" type="text" v-model="site.divisions[idx]" /> <br />
                                                    </div>
                                                    <button class="btn-cms-green" type="button" v-on:click="site.divisions.push('')">Add division</button>
                                                </div>
                                            </div>

                                            <div>
                                                <label>Authorised Registration Domains</label>
                                                <br />

                                                <div v-if="site.registrationEmailDomains && site.registrationEmailDomains.length == 0" style="font-weight: 100; margin-bottom: 10px">No Domains Configured</div>

                                                <div>
                                                    <input v-for="(domain, idx) in site.registrationEmailDomains" type="text" v-model="site.registrationEmailDomains[idx]" /> <br />
                                                </div>
                                                <button class="btn-cms-green" type="button" v-on:click="site.registrationEmailDomains.push('')">Add domain</button>
                                            </div>

                                            <div>
                                                <label>Certificate Email Template</label>
                                                <textarea rows="20" v-model="site.certificateEmailTemplate"></textarea>
                                            </div>
                                        </div>
                                        <div class="container-fluid site-design" v-if="activeTab == 'design'">
                                            <div class="row" style="border-bottom: 1px solid black;">
                                                <div class="col-12 site-design-tabs">
                                                    <div class="row">
                                                        <div class="col-12 d-flex justify-content-end">
                                                            <button class="btn-add text-nowrap" v-bind:class="{active: designTab == 'homePage'}" v-on:click="setDesignTab('homePage')">Home Page</button>
                                                            <button class="btn-add" v-bind:class="{active: designTab == 'navbar'}" v-on:click="setDesignTab('navbar')">Navbar</button>
                                                            <button class="btn-add" v-bind:class="{active: designTab == 'footer'}" v-on:click="setDesignTab('footer')">Footer</button>
                                                            <button class="btn-add" v-bind:class="{active: designTab == 'buttons'}" v-on:click="setDesignTab('buttons')">Buttons</button>
                                                            <button class="btn-add" v-bind:class="{active: designTab == 'accents'}" v-on:click="setDesignTab('accents')">Accents</button>
                                                            <button class="btn-add" v-bind:class="{active: designTab == 'content'}" v-on:click="setDesignTab('content')">Components</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="fields" v-if="site.siteDesign">
                                                <!--navbar-->
                                                <div v-if="designTab == 'navbar'">
                                                    <div class="title mt-4">
                                                        <h1>
                                                            Navbar
                                                        </h1>
                                                    </div>
                                                    <div class="row navbar-props">
                                                        <div class="col-12">
                                                            <div class="row">
                                                                <div class="col-6">
                                                                    <div class="d-flex flex-column text-center">
                                                                        <label>Logo</label>
                                                                        <img v-if="site.siteDesign.navigation.logoFileName" v-bind:src="site.siteDesign.navigation | s3url('logo')" class="image-preview ml-auto mr-auto" style=" height: 150px;" />
                                                                        <i v-else class="fa fa-5x fa-image ml-auto mr-auto mt-2 mb-2"></i>
                                                                        <label v-show="site.siteDesign.navigation.logoFileName">{{site.siteDesign.navigation.logoFileName}}</label>
                                                                        <input type="file" id="navLogo" hidden accept="image/*" @change="fileChanged($event.target, site.siteDesign.navigation, 'logo')" />
                                                                        <label for="navLogo" class="btn-cms-turq">Select file</label>
                                                                    </div>
                                                                </div>
                                                                <div class="col-6">
                                                                    <div class="d-flex flex-column text-center">
                                                                        <label>Favicon</label>
                                                                        <img v-if="site.siteDesign.faviconFileName" v-bind:src="site.siteDesign | s3url('favicon')" class="image-preview ml-auto mr-auto" style="height: 150px;" />
                                                                        <i v-else class="fa fa-5x fa-image ml-auto mr-auto  mt-2 mb-2"></i>
                                                                        <label v-show="site.siteDesign.faviconFileName">{{site.siteDesign.faviconFileName}}</label>
                                                                        <input type="file" hidden accept="image/*" id="favicon" @change="fileChanged($event.target, site.siteDesign, 'favicon')" />
                                                                        <label for="favicon" class="btn-cms-turq">Select file</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-6 d-flex flex-column justify-content-between">
                                                                    <label>Background Color</label>
                                                                    <input type="color" v-model="site.siteDesign.navigation.backgroundColor" />
                                                                </div>
                                                                <div class="col-6 d-flex flex-column justify-content-between">
                                                                    <label>Text Color</label>
                                                                    <input type="color" v-model="site.siteDesign.navigation.color" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--buttons-->
                                                <div v-if="designTab == 'buttons'">
                                                    <div class="title mt-4">
                                                        <h1>
                                                            Buttons
                                                        </h1>
                                                    </div>
                                                    <div class="row buttons-props mt-3">
                                                        <div class="col-6 d-flex flex-column">
                                                            <div class="title">
                                                                Primary
                                                            </div>
                                                            <div>
                                                                <label>Background Color</label>
                                                                <input type="color" v-model="site.siteDesign.buttons.primary.backgroundColor" />
                                                            </div>
                                                            <div>
                                                                <label>Text Color</label>
                                                                <input type="color" v-model="site.siteDesign.buttons.primary.color" />
                                                            </div>
                                                        </div>
                                                        <div class="col-6 d-flex flex-column justify-content-between">
                                                            <div class="title">
                                                                Secondary
                                                            </div>
                                                            <div>
                                                                <label>Background Color</label>
                                                                <input type="color" v-model="site.siteDesign.buttons.secondary.backgroundColor" />
                                                            </div>
                                                            <div>
                                                                <label>Text Color</label>
                                                                <input type="color" v-model="site.siteDesign.buttons.secondary.color" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--accents-->
                                                <div v-if="designTab == 'accents'">
                                                    <div class="title mt-4">
                                                        <h1>
                                                            Accents
                                                        </h1>
                                                    </div>
                                                    <div class="row mt-3 accents-props">
                                                        <div class="col-6 d-flex flex-column">
                                                            <div class="title">
                                                                Primary
                                                            </div>
                                                            <div>
                                                                <label>Background Color</label>
                                                                <input type="color" v-model="site.siteDesign.accents.primary.backgroundColor" />
                                                            </div>
                                                            <div>
                                                                <label>Text Color</label>
                                                                <input type="color" v-model="site.siteDesign.accents.primary.color" />
                                                            </div>
                                                        </div>
                                                        <div class="col-6 d-flex flex-column">
                                                            <div class="title">
                                                                Secondary
                                                            </div>
                                                            <div>
                                                                <label>Background Color</label>
                                                                <input type="color" v-model="site.siteDesign.accents.secondary.backgroundColor" />
                                                            </div>
                                                            <div>
                                                                <label>Text Color</label>
                                                                <input type="color" v-model="site.siteDesign.accents.secondary.color" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--homepage-->
                                                <div v-if="designTab == 'homePage'">

                                                    <div class="title mt-4">
                                                        <h1>
                                                            Home Page
                                                        </h1>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12 d-flex flex-column">
                                                            <div class="d-flex flex-column">
                                                                <label>Banner Image</label>
                                                                <img v-bind:src="site.siteDesign.homePage | s3url('banner')" class="image-preview" />
                                                                <label v-show="site.siteDesign.homePage.bannerFileName">{{site.siteDesign.homePage.bannerFileName}}</label>
                                                                <input type="file" hidden id="bannerImage" accept="image/*" @change="fileChanged($event.target, site.siteDesign.homePage, 'banner')" />
                                                                <label for="bannerImage" class="btn-cms-turq">Select file</label>
                                                            </div>
                                                            <div>
                                                                <label>Title</label>
                                                                <input type="text" v-model="site.siteDesign.homePage.title" />
                                                            </div>
                                                            <div>
                                                                <label>Subtitle</label>
                                                                <input type="text" v-model="site.siteDesign.homePage.subtitle" />
                                                            </div>
                                                            <div>
                                                                <label>Show Contact Info</label>
                                                                <input type="checkbox" v-model="site.siteDesign.homePage.showContactInfo" />
                                                            </div>
                                                            <div>
                                                                <label>Intro Title</label>
                                                                <input type="text" v-model="site.siteDesign.introTitle" />
                                                            </div>
                                                            <div>
                                                                <label>Intro Subtitle</label>
                                                                <input type="text" v-model="site.siteDesign.introSubtitle" />
                                                            </div>
                                                            <div>
                                                                <!--change to rich text-->
                                                                <label>Intro Description</label>
                                                                <textarea type="text" v-model="site.siteDesign.introDescription"> </textarea>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-2">
                                                                    <label>Banner Image Color Overlay</label>
                                                                    <input type="color" v-model="site.siteDesign.homePage.bannerBackgroundColor" />
                                                                </div>
                                                                <div class="col-2">
                                                                    <label>Banner Image Color Transparency</label>
                                                                    <input type="number" max="1" min="0" v-model="site.siteDesign.homePage.bannerBackgroundColorTransparency" />
                                                                </div>
                                                                <div class="col-2">
                                                                    <label>Background Color</label>
                                                                    <input type="color" v-model="site.siteDesign.homePage.backgroundColor" />
                                                                </div>
                                                                <div class="col-2">
                                                                    <label>Text Color</label>
                                                                    <input type="color" v-model="site.siteDesign.homePage.color" />
                                                                </div>
                                                                <div class="col-2" v-if="site.siteDesign.colors && site.siteDesign.colors.mainTitleText">
                                                                    <label>Main Title Color</label>
                                                                    <input type="color" v-model="site.siteDesign.colors.mainTitleText" />
                                                                </div>
                                                                <div class="col-2" v-if="site.siteDesign.colors && site.siteDesign.colors.selectedText">
                                                                    <label>Selected Text Color</label>
                                                                    <input type="color" v-model="site.siteDesign.colors.selectedText" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--footer-->
                                                <div v-if="designTab == 'footer'">
                                                    <div class="title mt-4">
                                                        <h1>
                                                            Footer
                                                        </h1>
                                                    </div>
                                                    <div class="row mt-3 footer-props">
                                                        <div class="col-12">
                                                            <div class="row">
                                                                <div class="col-6 d-flex flex-column">
                                                                    <div>
                                                                        <label>Address</label>
                                                                        <input type="text" v-model="site.siteDesign.footer.address" />
                                                                    </div>
                                                                    <div>
                                                                        <label>Contact Number</label>
                                                                        <input type="tel" v-model="site.siteDesign.footer.contactNumber" />
                                                                    </div>
                                                                    <div>
                                                                        <label>About Link</label>
                                                                        <input type="url" v-model="site.siteDesign.footer.aboutUrl" />
                                                                    </div>
                                                                    <div>
                                                                        <label>Email</label>
                                                                        <input type="email" v-model="site.siteDesign.footer.email" />
                                                                    </div>
                                                                    <div>
                                                                        <label>Background Color</label>
                                                                        <input type="color" v-model="site.siteDesign.footer.backgroundColor" />
                                                                    </div>
                                                                    <div>
                                                                        <label>Text Color</label>
                                                                        <input type="color" v-model="site.siteDesign.footer.color" />
                                                                    </div>
                                                                </div>
                                                                <div class="col-6">
                                                                    <div class="d-flex flex-column text-center">
                                                                        <label>Logo Footer</label>
                                                                        <label v-show="site.siteDesign.footer.logoFileName">{{site.siteDesign.footer.logoFileName}}</label>
                                                                        <img v-if="site.siteDesign.footer.logoFileName" v-bind:src="site.siteDesign.footer | s3url('logo')" class="image-preview ml-auto mr-auto" style="height: 150px;" />
                                                                        <i v-else class="fa fa-5x fa-image mb-2 mt-2 ml-auto mr-auto"></i>
                                                                        <input type="file" hidden id="footerLogo" accept="image/*" @change="fileChanged($event.target, site.siteDesign.footer, 'logo')" />
                                                                        <label for="footerLogo" class="btn-cms-turq">Select file</label>
                                                                    </div>
                                                                    <div class="d-flex flex-column mt-4 text-center">
                                                                        <label>Terms and Conditions PDF</label>
                                                                        <label v-show="site.siteDesign.footer.termsFileName">{{site.siteDesign.footer.termsFileName}}</label>
                                                                        <input type="file" accept="application/pdf" hidden id="termsPdf" @change="fileChanged($event.target, site.siteDesign.footer, 'terms')" />
                                                                        <br />
                                                                        <div class="row">
                                                                            <div class="col">
                                                                                <label class="btn-cms-turq w-100 h-100" for="termsPdf">Select file</label>
                                                                            </div>
                                                                            <div class="col-6" v-if="site.siteDesign.footer.termsFileName">
                                                                                <button class="btn btn-danger h-100 w-100" v-on:click="removePdf('terms')">Remove</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="d-flex flex-column mt-4 text-center">
                                                                        <label>Privacy Policy PDF</label>
                                                                        <label v-show="site.siteDesign.footer.privacyPolicyFileName">{{site.siteDesign.footer.privacyPolicyFileName}}</label>
                                                                        <input type="file" hidden accept="application/pdf" id="privacyPdf" @change="fileChanged($event.target, site.siteDesign.footer, 'privacyPolicy')" />
                                                                        <br />
                                                                        <div class="row">
                                                                            <div class="col">
                                                                                <label class="btn-cms-turq w-100 h-100" for="privacyPdf">Select file</label>
                                                                            </div>
                                                                            <div class="col-6" v-if="site.siteDesign.footer.privacyPolicyFileName">
                                                                                <button class="btn btn-danger h-100 w-100" v-on:click="removePdf('privacyPolicy')">Remove</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--content-->
                                                <div class="pl-3 pr-3 pb-3 mt-3" v-if="designTab == 'content'">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <div class="title mt-4">
                                                                <h1>
                                                                    Page Components
                                                                </h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row components-props">
                                                        <div class="col-3 mt-4 component-list">
                                                            <div class="card h-100 mt-2">

                                                                <div class="d-flex justify-content-center">
                                                                    <button v-on:click="addSiteComponent">Add New Component</button>
                                                                </div>
                                                                <ul class="list-group pt-0 sortable-list">
                                                                    <li class="list-group-item" v-if="site.siteDesign.components.length < 1">No content yet!</li>
                                                                    <li class="list-group-item componentTab" :key="component.id" v-bind:class="{activeComponentTab: activeComponent.id == component.id}" v-for="component in siteComponents" v-on:click="setActiveComponent(component)"
                                                                        draggable
                                                                        @dragstart="startDrag($event, component)"
                                                                        @drop="onDrop($event, component)"
                                                                        @dragover.prevent
                                                                        @dragenter.prevent>
                                                                        <div class="d-flex justify-content-between align-items-center">
                                                                            <i class="fa fa-bars"></i>
                                                                            <span style="max-width: 75%;" class="text-right">
                                                                                {{getCapitalized(activeComponent.type) + " Component"}}
                                                                            </span>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="col-9 mt-4">
                                                            <div v-if="site.siteDesign.components.length < 1" class="container-fluid mt-5 mb-3">
                                                                <div class="title text-center">
                                                                    No components yet!
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <div class="card component mt-2 pt-2" v-if="activeComponent">
                                                                        <div class="container-fluid">
                                                                            <div class="row mb-2">
                                                                                <div class="container-fluid d-flex justify-content-between align-items-center">
                                                                                    <div class="title ml-2">
                                                                                        {{getCapitalized(activeComponent.type)}}
                                                                                    </div>
                                                                                    <button class="btn btn-outline-danger mr-2" v-on:click="showDeleteModal('component', activeComponent)">Delete Component</button>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-12">
                                                                                    <div class="container-fluid">
                                                                                        <label>Component type</label>
                                                                                        <select v-model="activeComponent.type">
                                                                                            <option selected disabled hidden>Select a type</option>
                                                                                            <option value="html">Html</option>
                                                                                            <option value="text">Rich Text</option>
                                                                                            <option value="course">Course</option>
                                                                                            <option value="coursePackage">Course Package</option>
                                                                                            <option value="tiles">Tiles</option>
                                                                                            <option value="features">Features</option>
                                                                                            <option value="video">Video</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row comp-alignment" v-if="activeComponent.type == 'text' || activeComponent.type == 'html'">
                                                                                <div class="col-12">
                                                                                    <div class="row">
                                                                                        <div class="col-6">
                                                                                            <div class="container-fluid">
                                                                                                <div class="title">
                                                                                                    Alignment
                                                                                                </div>
                                                                                                <div class="d-flex">
                                                                                                    <div class="m-1">
                                                                                                        <label class="mr-2">Left</label>
                                                                                                        <input type="radio" v-model="activeComponent.alignment" value="left" />
                                                                                                    </div>
                                                                                                    <div class="m-1">
                                                                                                        <label class="mr-2">Center</label>
                                                                                                        <input type="radio" v-model="activeComponent.alignment" value="center" />
                                                                                                    </div>
                                                                                                    <div class="m-1">
                                                                                                        <label class="mr-2">Right</label>
                                                                                                        <input type="radio" v-model="activeComponent.alignment" value="right" />
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-6">
                                                                                            <div class="title">
                                                                                                Size
                                                                                            </div>
                                                                                            <div class="d-flex">
                                                                                                <div class="m-1">
                                                                                                    <label class="mr-2">Small</label>
                                                                                                    <input type="radio" value="small" v-model="activeComponent.size" />
                                                                                                </div>
                                                                                                <div class="m-1">
                                                                                                    <label class="mr-2">Medium</label>
                                                                                                    <input type="radio" value="medium" v-model="activeComponent.size" />
                                                                                                </div>
                                                                                                <div class="m-1">
                                                                                                    <label class="mr-2">Large</label>
                                                                                                    <input type="radio" value="large" v-model="activeComponent.size" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>h
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row mt-2 mb-3">
                                                                                <div class="col editor">
                                                                                    <div v-show="activeComponent.type == 'text'">
                                                                                        <rich-text-component v-on:htmlChanged="updateHtml" :initialComponent="component" />
                                                                                    </div>
                                                                                    <div v-show="activeComponent.type == 'html'">
                                                                                        <div class="container-fluid">
                                                                                            <textarea class="form-control" style="min-height: 450px;" v-model="activeComponent.html"></textarea>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-show="activeComponent.type == 'course'" class="mt-2">
                                                                                        <div class="row">
                                                                                            <div class="col-6">
                                                                                                <div class="d-flex flex-column">
                                                                                                    <div class="container-fluid mb-2">
                                                                                                        <select v-model="activeComponent.courseSelection" @change="selectionChanged($event, activeComponent)">
                                                                                                            <option selected value="multiple">Multiple courses</option>
                                                                                                            <option value="single">Single course</option>
                                                                                                            <option value="featured">Featured courses</option>
                                                                                                            <!--<option value="upcoming">Upcoming courses</option>-->
                                                                                                        </select>
                                                                                                    </div>
                                                                                                    <div class="container-fluid" v-show="activeComponent.courseSelection == 'multiple' || activeComponent.courseSelection == 'single'">
                                                                                                        <ul class="list-group">
                                                                                                            <li v-if="siteCourses" v-for="course in siteCourses" class="list-group-item">
                                                                                                                <div class="d-flex align-items-center justify-content-between mt-1">
                                                                                                                    {{course.name}}
                                                                                                                    <button class="btn btn-primary" v-on:click="addCourseToComponent(course, activeComponent)">Add</button>
                                                                                                                </div>
                                                                                                            </li>
                                                                                                        </ul>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="col-6">
                                                                                                <div class="card bg-dark-blue pb-2 h-100">
                                                                                                    <div class="container-fluid">
                                                                                                        <div class="title text-white">
                                                                                                            Selected Courses
                                                                                                        </div>
                                                                                                        <ul class="list-group" v-if="activeComponent.courseSelection == 'multiple' || activeComponent.courseSelection == 'single' || activeComponent.courseSelection == 'upcoming'">
                                                                                                            <li class="text-white text-center" v-if="activeComponent.courseIds.length < 1">
                                                                                                                <h3>No courses selected</h3>
                                                                                                            </li>
                                                                                                            <li v-for="id in activeComponent.courseIds" class="list-group-item">
                                                                                                                <div class="d-flex justify-content-between align-items-center">
                                                                                                                    {{getCourseName(id)}}
                                                                                                                    <button class="btn btn-danger" v-on:click="removeCourse(activeComponent, id)">Remove</button>
                                                                                                                </div>
                                                                                                            </li>
                                                                                                        </ul>
                                                                                                        <ul class="list-group" v-else>
                                                                                                            <li class="list-group-item" v-for="course in siteFeaturedCourses">
                                                                                                                {{course.name}}
                                                                                                            </li>
                                                                                                            <li v-show="siteFeaturedCourses.length < 1">No featured courses!</li>
                                                                                                        </ul>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                    <div v-show="activeComponent.type == 'coursePackage'">
                                                                                        <div class="container-fluid">
                                                                                            <div class="row">
                                                                                                <div class="col-12">
                                                                                                    <label>Package Title</label>
                                                                                                    <input type="text" v-model="activeComponent.text" />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="row" v-if="activeComponent.background">
                                                                                                <div class="col-6">
                                                                                                    <div class="d-flex flex-column text-center">
                                                                                                        <label>Background Image</label>
                                                                                                        <img v-if="activeComponent.background.imageFileName" v-bind:src="activeComponent.background | s3url('image')" class="image-preview ml-auto mr-auto" style=" height: 150px;" />
                                                                                                        <i v-else class="fa fa-5x fa-image ml-auto mr-auto mt-2 mb-2"></i>
                                                                                                        <label v-show="activeComponent.background.imageFileName">{{activeComponent.background.imageFileName}}</label>
                                                                                                        <input type="file" id="bgImage" hidden accept="image/*" @change="fileChanged($event.target, activeComponent.background, 'image')" />
                                                                                                        <label for="bgImage" class="btn-cms-turq">Select file</label>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-6">
                                                                                                    <div>

                                                                                                        <label>Background overlay</label>
                                                                                                        <input type="color" v-model="activeComponent.background.overlay" />
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <label>Background opacity</label>
                                                                                                        <input type="number" v-model="activeComponent.background.opacity" min="0.1" max="1.0" placeholder="0.1 = 10%" />
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="row">
                                                                                                <div class="col-6">
                                                                                                    <div class="d-flex flex-column">
                                                                                                        <div class="container-fluid">
                                                                                                            <ul class="list-group">
                                                                                                                <li v-if="siteCoursePackages.length < 1">No course packages yet!</li>
                                                                                                                <li v-for="coursePackage in siteCoursePackages" class="list-group-item">
                                                                                                                    <div class="d-flex align-items-center justify-content-between mt-1">
                                                                                                                        {{coursePackage.name}}
                                                                                                                        <button class="btn btn-primary" v-on:click="addCoursePackageToComponent(coursePackage, activeComponent)">Add</button>
                                                                                                                    </div>
                                                                                                                </li>
                                                                                                            </ul>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-6">
                                                                                                    <div class="container-fluid">
                                                                                                        <div class="title">
                                                                                                            Selected Course Packages
                                                                                                        </div>
                                                                                                        <ul class="list-group">
                                                                                                            <li v-for="id in activeComponent.coursePackageIds" class="list-group-item">
                                                                                                                <div class="d-flex justify-content-between align-items-center">
                                                                                                                    {{getCoursePackageName(id)}}
                                                                                                                    <button class="btn btn-danger" v-on:click="removeCoursePackage(activeComponent,id)">Remove</button>
                                                                                                                </div>
                                                                                                            </li>
                                                                                                        </ul>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <!--type multiple or single or featured-->
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-show="activeComponent.type == 'tiles'">
                                                                                        <div class="container-fluid">
                                                                                            <!--image, title, subtitle, link-->
                                                                                            <div class="row">
                                                                                                <div class="col-6">
                                                                                                    <div>
                                                                                                        <label>Title</label>
                                                                                                        <input type="text" v-model="activeComponent.title" />
                                                                                                    </div>
                                                                                                    <button class="btn btn-primary mt-2 mb-2 w-100" v-on:click="addTile(activeComponent)">Add Tile</button>
                                                                                                    <div>
                                                                                                        <ul class="list-group">
                                                                                                            <li v-for="tile in activeComponent.tiles" :key="tile.id" class="list-group-item mt-1">
                                                                                                                <div class="d-flex justify-content-between align-items-center">
                                                                                                                    {{tile.subtitle ? tile.subtitle : "No title"}}
                                                                                                                    <div>
                                                                                                                        <button class="btn btn-primary mr-2" v-on:click="editTile(activeComponent, tile)">Edit</button>
                                                                                                                        <button class="btn btn-outline-danger" v-on:click="showDeleteModal('tile', {component, tile})">Delete</button>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </li>
                                                                                                            <li v-if="activeComponent.tiles && activeComponent.tiles.length < 1" class="text-center">No tiles yet!</li>
                                                                                                        </ul>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-6" v-for="tile in activeComponent.tiles" :key="tile.id" v-show="activeComponent.activeTile.id == tile.id">
                                                                                                    <div class="card bg-dark-blue text-white pl-2 pr-2 pb-2 mt-5">
                                                                                                        <div class="title text-white">
                                                                                                            Tile Properties
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <label>Category</label>
                                                                                                            <input type="text" v-model="activeComponent.activeTile.title" />
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <label>Title</label>
                                                                                                            <input type="text" v-model="activeComponent.activeTile.subtitle" />
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <label>Title Font Size</label>
                                                                                                            <select v-model="tile.fontSize">
                                                                                                                <option value="small">Small</option>
                                                                                                                <option value="medium">Medium</option>
                                                                                                                <option value="large">Large</option>
                                                                                                            </select>
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <label>Link URL</label>
                                                                                                            <input type="url" v-model="activeComponent.activeTile.url" />
                                                                                                        </div>
                                                                                                        <div class="d-flex flex-column">
                                                                                                            <label>Image</label>
                                                                                                            <label v-show="activeComponent.activeTile.imageFileName">{{activeComponent.activeTile.imageFileName}}</label>
                                                                                                            <input type="file" hidden :id="activeComponent.activeTile.imageFileName" v-bind:hidden="activeComponent.activeTile.imageFileName !== ''" class="component-file" @change="fileChanged($event.target, activeComponent.activeTile, 'image')" />
                                                                                                            <img v-if="activeComponent.activeTile.imageFileName" v-bind:src="activeComponent.activeTile | s3url('image')" class="image-preview" />
                                                                                                            <i v-else class="fa fa-5x fa-image ml-auto mr-auto mb-2 mt-2"></i>
                                                                                                            <label class="btn-cms-turq mt-2" :for="activeComponent.activeTile.imageFileName">Select file</label>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-show="activeComponent.type == 'features'">
                                                                                        <div class="container-fluid">
                                                                                            <!--title, features-->
                                                                                            <div class="row">
                                                                                                <div class="col-6">
                                                                                                    <div>
                                                                                                        <label>Title</label>
                                                                                                        <input type="text" v-model="activeComponent.title" />
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <label>Background Color</label>
                                                                                                        <input type="color" v-model="activeComponent.backgroundColor" />
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <label>Text Color</label>
                                                                                                        <input type="color" v-model="activeComponent.color" />
                                                                                                    </div>
                                                                                                    <button class="btn btn-primary w-100 mt-2 mb-2" v-on:click="addFeature(activeComponent)">Add feature</button>
                                                                                                    <ul class="list-group">
                                                                                                        <li class="list-group-item" v-for="feature in activeComponent.features" :key="feature.id" v-bind:class="{activeFeature: activeComponent.activeFeature.id == feature.id}">
                                                                                                            <div class="d-flex justify-content-between align-items-center">
                                                                                                                <div>
                                                                                                                    {{feature.title ? feature.title : "No title"}}
                                                                                                                </div>
                                                                                                                <div class="d-flex flex-nowrap">
                                                                                                                    <button class="btn btn-outline-primary mr-2" v-on:click="editFeature(activeComponent, feature)">Edit</button>
                                                                                                                    <button class="btn btn-outline-danger" v-on:click="showDeleteModal('feature', {component, feature})">Delete</button>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </li>
                                                                                                    </ul>
                                                                                                </div>
                                                                                                <div class="col-6" v-for="feature in activeComponent.features" :key="feature.id" v-show="activeComponent.activeFeature.id == feature.id">
                                                                                                    <div class="card bg-dark-blue text-white pl-2 pr-2 pb-2 mt-5">
                                                                                                        <div class="title text-white">
                                                                                                            Feature Properties
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <label>Title</label>
                                                                                                            <input type="text" v-model="activeComponent.activeFeature.title" />
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <label>Description</label>
                                                                                                            <textarea type="text" v-model="activeComponent.activeFeature.description" />
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <label>Feature Image Type</label>
                                                                                                            <select v-model="activeComponent.activeFeature.imageType" @change="clearFeature(feature)">
                                                                                                                <option selected disabled hidden>Select a type</option>
                                                                                                                <option value="file">File</option>
                                                                                                                <option value="icon">Icon</option>
                                                                                                            </select>
                                                                                                        </div>
                                                                                                        <div v-if="activeComponent.activeFeature.imageType == 'icon'">
                                                                                                            <div>
                                                                                                                <label>Font Awesome Icon (class name)</label>
                                                                                                                <input type="text" v-model="activeComponent.activeFeature.icon" />
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                <label>Icon Color</label>
                                                                                                                <input type="color" v-model="activeComponent.activeFeature.iconColor" />
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                <label>Icon Size</label>
                                                                                                                <select v-model="feature.iconSize">
                                                                                                                    <option value="">1x</option>
                                                                                                                    <option value="fa-3x">3x</option>
                                                                                                                    <option value="fa-5x">5x</option>
                                                                                                                </select>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div v-else class="d-flex flex-column">
                                                                                                            <label>Image File</label>
                                                                                                            <label v-show="feature.imageFileName">{{feature.imageFileName}}</label>
                                                                                                            <input type="file" accept="image/*" :id="feature.id" hidden class="component-file" @change="fileChanged($event.target, feature, 'image')" />
                                                                                                            <img v-if="feature.imageFileName" v-bind:src="feature | s3url('image')" class="image-preview" />
                                                                                                            <i v-else class="fa fa-5x fa-image ml-auto mr-auto mb-2 mt-2"></i>
                                                                                                            <label :for="feature.id" class="btn-cms-turq">Select File</label>
                                                                                                            <div>
                                                                                                                <label>Image Size</label>
                                                                                                                <select v-model="feature.imageSize">
                                                                                                                    <option value="small">Small</option>
                                                                                                                    <option value="medium">Medium</option>
                                                                                                                    <option value="large">Large</option>
                                                                                                                </select>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-show="activeComponent.type == 'video'">
                                                                                        <div class="container-fluid">
                                                                                            <div class="row">
                                                                                                <div class="col-12">
                                                                                                    <div>
                                                                                                        <label>Title</label>
                                                                                                        <input type="text" v-model="activeComponent.title" />
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <label>Size</label>
                                                                                                        <select v-model="activeComponent.videoSize">
                                                                                                            <option value="card">Card</option>
                                                                                                            <option value="full">Full Width</option>
                                                                                                        </select>
                                                                                                    </div>
                                                                                                    <div class="row">
                                                                                                        <div class="col-6">
                                                                                                            <div>
                                                                                                                <label>Video Type</label>
                                                                                                                <select class="form-control" v-model="activeComponent.videoType">
                                                                                                                    <option selected disabled hidden>Select a type</option>
                                                                                                                    <option value="url">URL</option>
                                                                                                                    <option value="file">File</option>
                                                                                                                </select>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div class="col-6">
                                                                                                            <div class="d-flex flex-column" v-if="activeComponent.videoType == 'file'">
                                                                                                                <label>Video File</label>
                                                                                                                <label v-show="activeComponent.videoFileName">{{activeComponent.videoFileName}}</label>
                                                                                                                <label :for="activeComponent.videoFileName" v-show="activeComponent.videoFileName" class="btn-cms-turq">Select File</label>
                                                                                                                <input type="file" accept="video/*" :id="activeComponent.videoFileName" v-bind:hidden="activeComponent.videoFileName !== ''" class="component-file" @change="fileChanged($event.target, component, 'video')" />
                                                                                                            </div>
                                                                                                            <div v-else>
                                                                                                                <label>Video URL</label>
                                                                                                                <input type="url" v-model="activeComponent.videoURL" />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-6 preview" v-if="canPreview(activeComponent.type)">
                                                                                    <div class="card h-100">
                                                                                        <div class="container-fluid" v-if="activeComponent.type == 'html'" v-html="activeComponent.html">
                                                                                        </div>
                                                                                        <div class="container-fluid" v-if="activeComponent.type == 'text'" v-html="activeComponent.text">
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row mt-2 mb-2">
                                                                                <div class="col-12 d-flex justify-content-end">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div v-if="site">
                                        <label style="font-size: 22px; font-weight: 600; padding-top: 50px;">Notification Emails</label>
                                        <br />
                                        <div style="max-height: 600px; overflow-y: scroll;">
                                            <table class="table" style="background-color: white;">

                                                <thead>
                                                    <tr>
                                                        <th>Email</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(email, idx) in site.notificationEmails" :key="`${email}-${idx}`">

                                                        <td>{{ email }}</td>
                                                        <td>
                                                            <button class="btn-cms-red" v-on:click="removeNotificationEmail(idx)">Remove</button>
                                                        </td>

                                                    </tr>

                                                </tbody>

                                            </table>

                                        </div>
                                        <label style="font-size: 17px; font-weight: 600; padding-top: 10px;">Add notification email</label>
                                        <div class="d-flex align-items-center" style="gap: 10px; margin-top: 10px; margin-bottom: 15px;">
                                            <input type="email" v-model.trim="notificationEmailInput" placeholder="name@example.com" style="margin-bottom: 0;" />
                                            <button class="btn-cms-green" type="button" v-on:click="addNotificationEmail()">Add email</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-wrapper">
            <div class="card border-0" id="delete-modal">
                <div class="card-header bg-dark-blue text-white">
                    Confirm delete
                </div>
                <div class="card-body">
                    <div class="row mt-4">
                        <div class="col-12 text-center">
                            <h4>Are you sure you want to delete this {{deleteModalType}}</h4>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-12 d-flex justify-content-center">
                            <button class="btn btn-confirm-delete" v-on:click="deleteItem">Confirm</button>
                            <button class="btn btn-danger ml-2" v-on:click="resetDelete">Cancel</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped>

    /*.dragging-ghost {
        animation-name: drag;
        animation-duration: 2s;
        animation-iteration-count: infinite;
    }

    @keyframes drag {
        0% {
            transform: scale(1);
            transform: rotate(0deg);
            background-color: #3d3c79;
        }

        25% {
            transform: scale(1.1);
            transform: rotate(5deg);
        }

        50% {
            transform: scale(1.2);
            transform: rotate(-5deg);
        }

        75% {
            transform: scale(1.1);
            transform: rotate(5deg);
        }

        100% {
            background-color: #3d3c79;
            transform: scale(1);
            transform: rotate(-5deg);
        }
    }*/

    .modal-wrapper {
        position: fixed;
        z-index: 10000;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0,0,0,0.5);
    }

    #delete-modal {
        top: 200px;
        position: relative;
        width: 600px;
        height: 300px;
        left: 36%;
    }

    .btn-confirm-delete {
        background-color: #42C1C4;
        color: white;
    }

        .btn-confirm-delete:hover {
            background-color: white;
            color: #42C1C4;
        }

    .btn-cms-turq {
        text-align: center;
    }

    .active {
        background-color: white !important;
        border: 1px solid #282D69;
        border-bottom: none;
        color: #282D69;
    }

    .activeFeature {
        background-color: white !important;
        border: 1px solid #282D69;
        color: #282D69;
    }

    .activeComponentTab {
        background-color: white !important;
        border: 1px solid #282D69;
        color: #282D69;
    }

    .componentTab:hover {
        cursor: pointer;
        background-color: #282D69 !important;
        color: white;
    }

    .back-button {
        z-index: 1000;
        background-color: transparent !important;
        border: none;
        width: fit-content;
        justify-content: end !important;
        flex-direction: row !important;
        padding-right: 35px;
    }

    .btn-save {
        height: 50px;
        width: 100px;
        border-radius: 12px;
    }

    .btn-back {
        height: 50px;
        width: 100px;
        border-radius: 12px;
    }

    label {
        margin-top: 20px;
    }
</style>

<script>
    import MixinsFileUploads from '../../mixinsFileUploads';

    var options = {
        placeholder: 'Write text here',
        readOnly: false,
        theme: 'snow'
    };

    export default {
        name: 'AdminSitesDetails',
        mixins: [MixinsFileUploads],
        computed: {
            siteId() {
                // We will see what `params` is shortly
                return this.$route.params.id
            },
            siteFeaturedCourses() {
                var output = [];
                if (this.siteCourses) {
                    for (var i = 0; i < this.siteCourses.length; i++) {
                        var current = this.siteCourses[i];
                        if (current.promoted) {
                            output.push(current);
                        }
                    }
                }
                return output;
            },
            siteComponents() {
                return this.site && this.site.siteDesign && this.site.siteDesign.components ? this.site.siteDesign.components : [];
            }
        },
        data: function () {
            return {
                site: null,
                siteCourses: null,
                siteCoursePackages: null,
                notificationEmailInput: "",
                activeTab: null,
                designTab: null,
                activeComponent: null,
                draggingItem: null,
                mQuills: [],
                deleteModalType: null,
                deleteTarget: null,
                additionalProperties: null,
            }
        },


        methods: {
            removePdf(type) {
                var file = type + "File";
                var fileName = type + "FileName";
                this.site.siteDesign.footer[file] = null;
                this.site.siteDesign.footer[fileName] = "";
            },
            resetDelete() {
                this.deleteModalType = null;
                this.deleteTarget = null;
                $(".modal-wrapper").hide(500);
            },
            deleteItem() {
                var target = this.deleteTarget;
                var type = this.deleteModalType;

                switch (type) {
                    case "component":
                        this.deleteComponent(target)
                        break;
                    case "feature":
                        this.deleteFeature(target.component, target.feature);
                        break;
                    case "tile":
                        this.deleteTile(target.component, target.tile);
                        break;
                    default:
                        console.log("Unhandled delete type");
                        break;
                }
                this.resetDelete();
            },
            showDeleteModal(type, target) {
                //implement
                this.deleteModalType = type;
                this.deleteTarget = target;
                $(".modal-wrapper").show(500);
            },
            clearFeature(feature) {
                feature.imageFileName = "";
                feature.icon = '';
            },
            addAlpha(color, opacity) {
                var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
                return color + _opacity.toString(16).toUpperCase();
            },
            //implement
            goBack() {
                this.$router.push({ name: "AdminSites" })
            },
            startDrag(evt, item) {
                console.log({ evt, item });
                var element = evt.target;
                element.classList.add("dragging");

                if (this.draggingItem == null) {
                    this.draggingItem = item;
                }

                var img = new Image();
                img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
                evt.dataTransfer.setDragImage(img, 0, 0);
                evt.dataTransfer.dropEffect = 'move'
                evt.dataTransfer.effectAllowed = 'move'
                evt.dataTransfer.setData('itemID', item.id)
            },
            onDrop(evt, target) {
                console.log({ evt, target });
                evt.preventDefault();
                if (this.draggingItem !== null) {
                    this.itemMove(this.draggingItem, target);
                }
                else {
                    console.log("Dragging item null");
                }
            },
            itemMove(item, target) {
                var comps = this.site.siteDesign.components;
                var itemIndex = comps.indexOf(item);
                var targetIndex = comps.indexOf(target);
                this.site.siteDesign.components.splice(itemIndex, 1, target);
                this.site.siteDesign.components.splice(targetIndex, 1, item);
                $(".componentTab").removeClass("dragging");
                this.draggingItem = null;
            },
            setActiveComponent(component) {
                this.activeComponent = component;
            },
            setDesignTab(tab) {
                this.designTab = tab;

                if (tab === "content") {
                    this.$nextTick(() => this.initializeQuills());
                }
                if (tab === "content") {
                    var column = document.querySelector(".sortable-list");
                    //new Sortable(column, {
                    //    animation: 150,
                    //    ghostClass: "dragging-ghost",
                    //});
                }
            },
            selectionChanged(event, component) {
                var value = event.target.value;
                component.courseIds = [];
                switch (value) {
                    case "single":
                        break;
                    case "multiple":
                        break;
                    case "featured":
                        //check component courseIds has all featured courses
                        var featured = this.siteFeaturedCourses;
                        for (var i = 0; i < featured.length; i++) {
                            var id = featured[i].id;
                            component.courseIds.push(id);
                        }
                        break;
                    default:
                        break;
                }

            },
            editFeature(activeComponent, feature) {
                activeComponent.activeFeature = feature;
            },
            deleteFeature(component, feature) {
                activeComponent.features = activeComponent.features.filter(x => x.id !== feature.id);
            },
            addFeature(activeComponent) {
                //fa will be 1x size
                var feature = {
                    title: null,
                    description: null,
                    imageType: 'icon',
                    imageFileName: "",
                    icon: null,
                    iconSize: 'fa ',
                    imageSize: 'small',
                    id: this.$uuid.v4(),
                }

                if (activeComponent.features == undefined) {
                    activeComponent.features = [];
                }
                activeComponent.activeFeature = feature;
                activeComponent.features.push(feature);
            },
            editTile(activeComponent, tile) {
                activeComponent.activeTile = tile;
            },
            deleteTile(component, tile) {
                activeComponent.tiles = activeComponent.tiles.filter(x => x.id !== tile.id);
            },
            addTile(activeComponent) {
                var tile = {
                    title: null,
                    subtitle: null,
                    url: null,
                    imageFileName: "",
                    id: this.$uuid.v4(),
                }

                if (activeComponent.tiles == undefined) {
                    activeComponent.tiles = [];
                }
                activeComponent.activeTile = tile;
                activeComponent.tiles.push(tile);
            },
            getCapitalized(string) {
                var first = string[0].toUpperCase();
                var rest = string.slice(1);
                return first + rest;
            },
            canPreview(type) {
                if (type == "text" || type == "html") {
                    return true;
                }
                return false;
            },
            deleteComponent(component) {
                this.site.siteDesign.components = this.site.siteDesign.components.filter(x => x.id !== component.id);
                if (this.site.siteDesign.components.length > 0) {
                    this.activeComponent = this.site.siteDesign.components[0];
                }
            },
            removeCourse(activeComponent, id) {
                for (var i = 0; i < this.site.siteDesign.components.length; i++) {
                    var current = this.site.siteDesign.components[i];
                    if (current.id == activeComponent.id) {
                        if (!current.courseIds) {
                            current.courseIds = [];
                        }
                        current.courseIds = current.courseIds.filter(x => x !== id);
                        break;
                    }
                }
            },
            removeCoursePackage(component, id) {
                for (var i = 0; i < this.site.siteDesign.components.length; i++) {
                    var current = this.site.siteDesign.components[i];
                    if (current.id == component.id) {
                        if (!current.coursePackageIds) {
                            current.coursePackageIds = [];
                        }
                        current.coursePackageIds = current.coursePackageIds.filter(x => x !== id);
                        break;
                    }
                }
            },
            addCourseToComponent(course, activeComponent) {
                for (var i = 0; i < this.site.siteDesign.components.length; i++) {
                    var current = this.site.siteDesign.components[i];
                    if (current.id == activeComponent.id) {
                        if (current.courseIds == undefined) {
                            current.courseIds = [];
                        }
                        if (!current.courseIds.includes(course.id)) {
                            if (activeComponent.courseSelection == "multiple" || (activeComponent.courseSelection == "single" && current.courseIds.length < 1) || activeComponent.courseSelection == 'upcoming') {
                                current.courseIds.push(course.id);
                            }
                            break;
                        }
                    }
                }
            },
            getCoursePackageName(coursePackageId) {
                for (var i = 0; i < this.siteCoursePackages.length; i++) {
                    var coursePackage = this.siteCoursePackages[i];
                    if (coursePackage.id == coursePackageId) {
                        return coursePackage.name;
                    }
                }
            },
            addCoursePackageToComponent(coursePackage, activeComponent) {
                for (var i = 0; i < this.site.siteDesign.components.length; i++) {
                    var current = this.site.siteDesign.components[i];
                    if (current.id == activeComponent.id) {
                        if (current.coursePackageIds == undefined) {
                            current.coursePackageIds = [];
                        }
                        if (!current.coursePackageIds.includes(coursePackage.id)) {
                            current.coursePackageIds.push(coursePackage.id);
                            break;
                        }
                    }
                }
            },
            getCourseName(courseId) {
                if (this.siteCourses) {
                    for (var i = 0; i < this.siteCourses.length; i++) {
                        var course = this.siteCourses[i];
                        if (course.id == courseId) {
                            return course.name;
                        }
                    }
                }
            },
            updateHtml(value, id) {
                var component = this.site.siteDesign.components.filter(x => x.id == id);
                component[0].text = value;
            },
            setTab(event, tab) {
                $(".tab").removeClass("active");
                $(event.target).addClass('active');
                this.activeTab = tab;
            },
            initializeQuills() {
                var quills = $(".rich-text");
                if (quills && quills.length > 0) {
                    for (var i = 0; i < quills.length; i++) {
                        var quill = new Quill(quills[i], options);
                        var val = $(quill.container).siblings(".text-value").val();

                        if (val != null && val != "") {
                            quill.setContents(JSON.parse(val));
                        }

                        if (this.mQuills.indexOf(quill) < 0) {
                            this.mQuills.push(quill);
                        }
                    }
                }
            },
            async save() {
                debugger;
                await this.uploadFilesAsync(this.site.siteDesign.homePage, "banner");
                await this.uploadFilesAsync(this.site.siteDesign.navigation, "logo");
                await this.uploadFilesAsync(this.site.siteDesign.footer, "logo");

                await this.uploadFilesAsync(this.site.siteDesign.footer, "privacyPolicy");
                await this.uploadFilesAsync(this.site.siteDesign.footer, "terms");
                delete this.site.siteDesign.footer.termsFile;
                delete this.site.siteDesign.footer.privacyPolicyFile;

                //this.site.siteDesign.colors = {
                //    mainTitleText: "#ffffff",
                //    selectedText: "#ffffff",
                //}
                await this.uploadFilesAsync(this.site.siteDesign, "favicon");


                for (var i = 0; i < this.site.siteDesign.components.length; i++) {
                    var current = this.site.siteDesign.components[i];

                    if (current.type == 'tiles') {
                        for (var j = 0; j < current.tiles.length; j++) {
                            var tile = current.tiles[j];
                            if (tile.imageFileName !== '') {
                                await this.uploadFilesAsync(tile, "image");
                            }
                        }
                    }
                    else if (current.type == 'video') {
                        await this.uploadFilesAsync(current, "video");
                    }
                    else if (current.type == 'features') {
                        for (var j = 0; j < current.features.length; j++) {
                            var feature = current.features[j];
                            if (feature.imageType == 'file' && feature.imageFileName !== '') {
                                await this.uploadFilesAsync(feature, "image");
                            }
                        }
                    }
                    else if (current.type == 'coursePackage') {
                        if (current.background) {
                            await this.uploadFilesAsync(current.background, "image");
                        }
                    }

                }

                let vm = JSON.parse(JSON.stringify(this.site));

                if (!this.site.siteDesign.colors) {
                    this.site.siteDesign.colors = {
                        mainTitleText: "#ffffff",
                        selectedText: "#ffffff",
                    }
                }
                else if (!this.site.siteDesign.colors.mainTitleText) {
                    this.site.siteDesign.colors.mainTitleText = "#ffffff";
                }
                else if (!this.site.siteDesign.colors.selectedText) {
                    this.site.siteDesign.colors.selectedText = "#ffffff";

                }

                var styleString = this.createCssString(vm.siteDesign);
                vm.siteDesign.css = styleString;
                console.log(vm.siteDesign);
                vm.siteDesign = JSON.stringify(vm.siteDesign);
                vm = await this.web('/sites', "Uploading site data", vm);

                if (vm.siteDesign) {
                    vm.siteDesign = JSON.parse(vm.siteDesign);
                }

                if (vm.id != this.siteId) {
                    this.$router.replace("/admin/sites/" + vm.id);
                    this.$router.go();
                }
                else {
                    this.site = vm;
                }
            },
            createCssString(design) {
                if (design) {
                    var styleString = "";

                    var classes = [
                        ".accent-primary-bg",
                        ".accent-primary-tx",
                        ".accent-secondary-bg",
                        ".accent-secondary-tx",
                        ".accent-primary-bs",
                        ".accent-secondary-bs",
                        ".accent-primary-bs-card",
                        ".accent-secondary-bs-card",
                        ".accent-primary-bd",
                        ".accent-secondary-bd",
                        ".accent-primary-bd-bottom",
                        ".accent-secondary-bd-bottom",
                        ".home-bg",
                        ".home-tx",
                        ".nav-bg",
                        ".nav-tx",
                        ".footer-bg",
                        ".footer-tx",
                        ".btn-site-primary",
                        ".btn-site-primary:hover",
                        ".btn-site-secondary",
                        ".btn-site-secondary:hover",
                        ".banner-bg-tr",
                        "#loading-overlay .loader:before,#loading-overlay .loader:after",
                        ".lds-roller div:after",
                        ".item-content li:before",
                        ".tab-title.type1 li:after",
                        ".features li:before",
                        ".tab-title .active",
                        ".quick-link .heading-rg span:before",
                        ".main-title-text",
                        ".content .selected",
                        ".name a:hover",
                    ]

                    for (var i = 0; i < classes.length; i++) {
                        var c = classes[i];
                        var stringClass = "";
                        switch (c) {
                            case ".accent-primary-bg":
                                stringClass = `${c}{background-color: ${design.accents.primary.backgroundColor}!important; }`
                                break;
                            case ".accent-primary-tx":
                                stringClass = `${c}{color: ${design.accents.primary.color}!important; }`
                                break;
                            case ".accent-primary-bs":
                                stringClass = `${c}{box-shadow: ${design.accents.primary.backgroundColor} 0px -11px 0px 0px!important}`
                                break;
                            case ".accent-primary-bd":
                                stringClass = `${c}{border: 1px solid ${design.accents.primary.backgroundColor}!important}`
                                break;
                            case ".accent-primary-bd-bottom":
                                stringClass = `${c}{border-bottom: 4px solid ${design.accents.primary.backgroundColor}!important}`
                                break;
                            case ".accent-secondary-bg":
                                stringClass = `${c}{background-color: ${design.accents.secondary.backgroundColor}!important; }`
                                break;
                            case ".accent-secondary-tx":
                                stringClass = `${c}{color: ${design.accents.secondary.color}!important; }`
                                break;
                            case ".accent-secondary-bs":
                                stringClass = `${c}{box-shadow: ${design.accents.secondary.backgroundColor} 0px -11px 0px 1px!important}`
                                break;
                            case ".accent-secondary-bd":
                                stringClass = `${c}{border: 1px solid ${design.accents.secondary.backgroundColor}!important}`
                                break;
                            case ".accent-secondary-bd-bottom":
                                stringClass = `${c}{border-bottom: 4px solid ${design.accents.secondary.backgroundColor}!important}`
                                break;
                            case ".nav-bg":
                                stringClass = `${c}{background-color: ${design.navigation.backgroundColor}!important; }`
                                break;
                            case ".nav-tx":
                                stringClass = `${c}{color: ${design.navigation.color}!important; }`
                                break;
                            case ".footer-bg":
                                stringClass = `${c}{background-color: ${design.footer.backgroundColor}!important; }`
                                break;
                            case ".footer-tx":
                                stringClass = `${c}{color: ${design.footer.color}!important; }`
                                break;
                            case ".home-bg":
                                stringClass = `${c}{background-color: ${design.homePage.backgroundColor}!important; }`
                                break;
                            case ".home-tx":
                                stringClass = `${c}{color: ${design.homePage.color}!important; }`
                                break;
                            case ".btn-site-primary":
                                stringClass = `${c}{color: ${design.buttons.primary.color}!important; background-color: ${design.buttons.primary.backgroundColor}!important; border: 1px solid ${design.buttons.primary.color}!important;}`
                                break;
                            case ".btn-site-secondary":
                                stringClass = `${c}{color: ${design.buttons.secondary.color}!important; background-color: ${design.buttons.secondary.backgroundColor}!important;  border: 1px solid ${design.buttons.secondary.color}!important;}`
                                break;
                            case ".btn-site-primary:hover":
                                stringClass = `${c}{color: ${design.buttons.primary.backgroundColor}!important; background-color: ${design.buttons.primary.color}!important;  border: 1px solid ${design.buttons.primary.backgroundColor}!important;}`
                                break;
                            case ".btn-site-secondary:hover":
                                stringClass = `${c}{color: ${design.buttons.secondary.backgroundColor}!important; background-color: ${design.buttons.secondary.color}!important;  border: 1px solid ${design.buttons.secondary.backgroundColor}!important;}`
                                break;
                            case ".banner-bg-tr":
                                stringClass = `${c}{background-color: ${this.addAlpha(design.homePage.bannerBackgroundColor, design.homePage.bannerBackgroundColorTransparency)}!important;}`
                                break;
                            case ".accent-primary-bs-card":
                                stringClass = `${c}{box-shadow: ${design.accents.primary.backgroundColor} 1px 0px 14px -4px!important;}`
                                break;
                            case ".accent-secondary-bs-card":
                                stringClass = `${c}{box-shadow: ${design.accents.secondary.backgroundColor} 1px 0px 14px -4px!important;}`
                                break;
                            case ".banner-bg-tr":
                                stringClass = `${c}{background-color: ${this.addAlpha(design.homePage.bannerBackgroundColor, design.homePage.bannerBackgroundColorTransparency)}!important;}`
                                break;
                            case "#loading-overlay .loader:before,#loading-overlay .loader:after":
                                stringClass = `${c}{background: ${design.accents.primary.backgroundColor}!important;}`
                                break;
                            case ".lds-roller div:after":
                                stringClass = `${c}{background: ${design.accents.primary.backgroundColor}!important;}`
                                break;
                            case ".item-content li:before":
                                stringClass = `${c}{color: ${design.accents.secondary.color}!important;}`
                                break;
                            case ".tab-title.type1 li:after":
                                stringClass = `${c}{border-top: 12px solid ${design.accents.secondary.color}!important;}`
                                break;
                            case ".features li:before":
                                stringClass = `${c}{color: ${design.accents.secondary.color}!important;}`
                                break;
                            case ".tab-title .active":
                                stringClass = `${c}{color: ${design.accents.secondary.color}!important; background-color: ${design.accents.secondary.backgroundColor}!important;}`
                                break;
                            case ".quick-link .heading-rg span:before":
                                stringClass = `${c}{color: ${design.accents.secondary.color}!important;}`
                                break;
                            case ".main-title-text":
                                stringClass = `${c}{color: ${design.colors.mainTitleText}!important;}`
                                break;
                            case ".content .selected":
                                stringClass = `${c}{color: ${design.colors.selectedText}!important;}`
                                break;
                            case ".name a:hover":
                                stringClass = `${c}{color: ${design.colors.selectedText}!important; font-size: 22px!important;}`
                                break;
                            default:
                                break;
                        }

                        styleString += stringClass;
                    }
                    return styleString;
                }
            },
            addNotificationEmail() {
                var email = (this.notificationEmailInput || "").trim();
                if (!email) {
                    return;
                }

                if (!this.site.notificationEmails) {
                    this.site.notificationEmails = [];
                }

                var exists = this.site.notificationEmails.some(x => x && x.toLowerCase() === email.toLowerCase());
                if (!exists) {
                    this.site.notificationEmails.push(email);
                }

                this.notificationEmailInput = "";
            },
            removeNotificationEmail(idx) {
                if (idx != -1) {
                    this.site.notificationEmails.splice(idx, 1);
                }
            },
            fileChanged(target, reference, key) {
                //get files
                debugger;
                var validFiles = false;
                var input = $(target)[0];
                var files = input.files;
                //validate file sizes
                if (files.length > 0) {
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        if (file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png") {
                            var fileSizeMb = file.size / 1024 / 1024;
                            if (fileSizeMb > 2) {
                                alert("Image file size is greater than 2mb please use a smaller image");
                            }
                            else {
                                if (fileSizeMb > 1 && fileSizeMb <= 2) {
                                    alert("Image file size is greater than 1mb this may affect site performance consider resizing the image or choosing another one.")
                                }
                                validFiles = true;
                            }
                        }
                        else {
                            //allow other file types
                            validFiles = true;
                        }
                    }
                }
                if (validFiles) {
                    this.onFileChange(target, reference, key);
                }
            },
            addSiteComponent() {
                var newComp = {
                    type: "text",
                    html: null,
                    text: null,
                    color: "#ffffff",
                    backgroundColor: "#ffffff",
                    courseSelection: "multiple",
                    courseIds: [],
                    tiles: [],
                    features: [],
                    activeTile: null,
                    videoFileName: "",
                    videoSize: "full",
                    videoType: 'url',
                    activeFeature: null,
                    coursePackageIds: [],
                    alignment: "left",
                    size: "medium",
                    id: this.$uuid.v4(),
                    background: {
                        imageFileName: null,
                        overlay: "#ffffff"
                    }
                }
                if (!this.site.siteDesign.components) {
                    this.site.siteDesign.components = [];
                }
                this.site.siteDesign.components.push(newComp);
                this.activeComponent = newComp;
            },
        },
        async mounted() {

            $(".modal-wrapper").hide();
            const [site, siteCourses, siteCoursePackages, additionalPropertiesResponse] = await Promise.all([
                this.web('/sites/' + this.siteId, "Loading site"),
                this.web("/courses/site/" + this.siteId, "Loading site courses"),
                this.web("/coursePackages/site/" + this.siteId, "Loading site course packages"),
                this.web("/sites/GetAdditionalProperties", "Loading additional properties")
            ]);

            this.siteCourses = siteCourses;
            this.siteCoursePackages = siteCoursePackages;
            this.additionalProperties = additionalPropertiesResponse.properties;
            //if site has properties enable these

            //if new site
            if (!site.siteDesign) {
                site.siteDesign = {
                    components: [],
                    css: "",
                    faviconFileName: "",
                    homePage: {
                        bannerFileName: "",
                        title: "",
                        subtitle: "",
                        showContactInfo: false,
                        backgroundColor: '#ffffff',
                        bannerBackgroundColor: '#ffffff',
                        bannerBackgroundColorTransparency: '0',
                        color: '#333333',
                    },
                    accents: {
                        primary: {
                            backgroundColor: '#ffffff',
                            color: '#ffffff',
                        },
                        secondary: {
                            backgroundColor: '#ffffff',
                            color: '#ffffff',
                        },
                    },
                    navigation: {
                        backgroundColor: '#ffffff',
                        color: '#ffffff',
                        logoFileName: "",
                        logoLightFileName: "",
                    },
                    footer: {
                        address: "",
                        contactNumber: "",
                        email: "",
                        logoFileName: "",
                        privacyPolicyFileName: "",
                        termsFileName: "",
                        color: "#333333",
                        backgroundColor: "#ffffff"
                    },
                    buttons: {
                        primary: {
                            backgroundColor: '#ffffff',
                            color: '#ffffff',
                        },
                        secondary: {
                            backgroundColor: '#ffffff',
                            color: '#ffffff',
                        },
                    },
                    colors: {
                        mainTitleText: "#ffffff",
                        selectedText: "#ffffff",
                    }
                };
            }
            else {
                if (site.siteDesign) {

                    var parsed = JSON.parse(site.siteDesign);
                    site.siteDesign = parsed;
                    delete site.siteDesign.footer.termsFile;
                    var components = site.siteDesign.components;
                    //find better way to handle the files
                    for (var i = 0; i < components.length; i++) {
                        var current = components[i];
                        if (current.background && current.background.imageFile) {
                            delete current.background.imageFile;
                        }
                    }

                    if (!site.siteDesign.colors)
                        site.siteDesign.colors = {};

                    if (!site.siteDesign.colors.mainTitleText)
                        site.siteDesign.colors.mainTitleText = "#ffffff";

                    if (!site.siteDesign.colors.selectedText)
                        site.siteDesign.colors.selectedText = "#ffffff";
                }
            }

            if (!site.divisions)
                site.divisions = [];
            if (!site.notificationEmails)
                site.notificationEmails = [];
            if (!site.registrationEmailDomains)
                site.registrationEmailDomains = [];
            if (!site.additionalProperties)
                site.additionalProperties = [];

            this.site = site;

            var crumbs = {};
            crumbs["/admin/sites"] = "Sites";
            crumbs["/admin/sites/" + this.siteId] = (this.siteId == 0 ? "New" : this.site.name);
            this.$store.commit("breadCrumbs", crumbs);
            this.activeTab = "info";
            this.designTab = "homePage";
            if (this.site.siteDesign && this.site.siteDesign.components.length > 0) {
                this.activeComponent = this.site.siteDesign.components[0];
            }
        },
    }
</script>
